import styled from 'styled-components';
import { frameworks } from './SkillsData';
import { skillsColor } from '../../Components/Helpers/GlobalStyle';

const ChartsAnimationF = (props) => {
  return (
    <div id="chartsF" className={props.className}>
      <div className="box">
        <div className="barChart">
          <div className="animation" id="react"></div>
        </div>
        <div className="name"> {frameworks[0].name}</div>
      </div>

      <div className="box">
        <div className="barChart">
          <div className="animation" id="vue"></div>
        </div>
        <div className="name"> {frameworks[1].name}</div>
      </div>
    </div>
  );
};

export default styled(ChartsAnimationF)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  @media (max-width: 768px) {
    align-items: center;
  }

  .box {
    padding: 0.4rem;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .barChart {
    border: solid 3px ${skillsColor};
    border-radius: 100px;
    line-height: 1rem;
    width: 100%;
  }

  .animation {
    background-color: ${skillsColor};
    width: 0;
    height: 0.8rem;
    margin: 0.2rem;
    border-radius: 100px;
    line-height: 0.8rem;
  }

  .name {
    padding-left: 1rem;
    text-align: start;
    font-weight: bold;
  }

  #react {
    animation: react 4s ease-in 1s alternate both;
  }
  #vue {
    animation: vue 4s ease-in 1s alternate both;
  }

  @keyframes react {
    100% {
      width: ${`${frameworks[0].percent}%`};
    }
  }

  @keyframes vue {
    100% {
      width: ${`${frameworks[1].percent}%`};
    }
  }
`;
